import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.3_@babel+core@7.24.4_@opentelemetry+api@1.8.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Logo"] */ "/app/src/components/common/Logo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BlockNumber"] */ "/app/src/components/home/BlockNumber.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EntranceButton"] */ "/app/src/components/home/EntranceButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Integration"] */ "/app/src/components/home/Integrations.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ShowCase"] */ "/app/src/components/home/Showcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/app/src/components/ui/Button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Image"] */ "/app/src/components/ui/Image.tsx");
